"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class ValidationService extends client_1.RWSService {
    validateData(data) {
        const errors = [];
        const warnings = [];
        if (data.length === 0) {
            errors.push('No valid training data found');
        }
        // Check for empty inputs/outputs
        const emptyInputs = data.filter(item => !item.input.trim()).length;
        const emptyOutputs = data.filter(item => !item.output.trim()).length;
        if (emptyInputs > 0) {
            errors.push(`${emptyInputs} items have empty input fields`);
        }
        if (emptyOutputs > 0) {
            errors.push(`${emptyOutputs} items have empty output fields`);
        }
        // Check for duplicates
        const inputSet = new Set();
        let duplicates = 0;
        data.forEach(item => {
            if (inputSet.has(item.input)) {
                duplicates++;
            }
            else {
                inputSet.add(item.input);
            }
        });
        if (duplicates > 0) {
            warnings.push(`${duplicates} duplicate input entries found`);
        }
        // Check data quality
        if (data.length < 10) {
            warnings.push('Very small dataset - consider adding more training examples');
        }
        return {
            isValid: errors.length === 0,
            errors,
            warnings
        };
    }
    calculateDataStatistics(data) {
        if (data.length === 0) {
            return {
                totalSamples: 0,
                averageInputLength: 0,
                averageOutputLength: 0,
                categories: [],
                qualityScore: 0
            };
        }
        const totalSamples = data.length;
        const averageInputLength = Math.round(data.reduce((sum, item) => sum + item.input.length, 0) / totalSamples);
        const averageOutputLength = Math.round(data.reduce((sum, item) => sum + item.output.length, 0) / totalSamples);
        const categorySet = new Set();
        data.forEach(item => {
            if (item.category) {
                categorySet.add(item.category);
            }
        });
        const categories = Array.from(categorySet);
        // Simple quality score calculation
        const validItems = data.filter(item => item.input.trim().length > 0 &&
            item.output.trim().length > 0).length;
        const qualityScore = Math.round((validItems / totalSamples) * 100);
        return {
            totalSamples,
            averageInputLength,
            averageOutputLength,
            categories,
            qualityScore
        };
    }
    validateTrainingEntry(entry) {
        const errors = [];
        if (!entry.input.trim()) {
            errors.push('Input field is required');
        }
        if (!entry.output.trim()) {
            errors.push('Output field is required');
        }
        if (entry.input.length > 4000) {
            errors.push('Input field is too long (max 4000 characters)');
        }
        if (entry.output.length > 4000) {
            errors.push('Output field is too long (max 4000 characters)');
        }
        return {
            isValid: errors.length === 0,
            errors
        };
    }
}
exports.ValidationServiceInstance = ValidationService;
exports.default = ValidationService.getSingleton();
